import React from 'react'
import { DomainNotificationBuilderView } from '../../components/notification-builder/views/domain-notification-builder-view'

export const MobileSendNotification = () => {
    return (
        <DomainNotificationBuilderView
            isMobile={true}
            formMode="create"
            hideEstimatedReach={true}
            hidePreview={true}
            hideVariantManager={true}
            hideTestConfig={true}
            hidePushlyAiToggle={true}
        />
    )
}
